import { useBusinessStore } from '@/store/businessStore';

/**
 * Project (business) scope for data queries.
 * - businessId: the selected project id, or null for "All Projects".
 * - scopeParams: spread into an API params object ({ business_id } or {}).
 * - scopeKey: put in a queryKey so queries refetch when the project changes.
 *
 * Usage:
 *   const { businessId, scopeParams, scopeKey } = useBusinessScope();
 *   useQuery({ queryKey: ['posts', scopeKey], queryFn: () => postsApi.list(scopeParams) });
 */
export function useBusinessScope() {
  const businessId = useBusinessStore((s) => s.currentBusinessId) || null;
  return {
    businessId,
    scopeParams: businessId ? { business_id: businessId } : {},
    scopeKey: businessId || 'all',
  };
}

export default useBusinessScope;
